<header class="header">
  <div class="container">
    <div class="header__logo">
      <img src="branding/logo/z_logo.png" alt="Zapphira.ai Logo" class="header__logo-img" />
      <span class="header__logo-text">Zapphira.ai</span>
    </div>
    
    <nav class="header__nav">
      <ul class="header__nav-list">
        <li class="header__nav-item"><a href="#" class="header__nav-link header__nav-link--active">Inicio</a></li>
        <li class="header__nav-item"><a href="#" class="header__nav-link">Soluciones</a></li>
        <li class="header__nav-item"><a href="#" class="header__nav-link">Características</a></li>
        <li class="header__nav-item"><a href="#" class="header__nav-link">Precios</a></li>
        <li class="header__nav-item"><a href="#" class="header__nav-link">Demo</a></li>
        <li class="header__nav-item"><a href="#" class="header__nav-link">Blog</a></li>
      </ul>
    </nav>
    
    <div class="header__actions">
      <button class="header__login-btn">Iniciar sesión</button>
      <button class="header__contact-btn">Contactar ventas</button>
    </div>
    
    <!-- Botón de menú móvil -->
    <button class="header__mobile-menu" aria-label="Menú" (click)="toggleMobileMenu()">
      <span class="header__mobile-menu-bar"></span>
      <span class="header__mobile-menu-bar"></span>
      <span class="header__mobile-menu-bar"></span>
    </button>
  </div>
  
  <!-- Menú móvil (oculto por defecto) -->
  <div class="header__mobile-nav" [class.header__mobile-nav--active]="isMobileMenuOpen">
    <ul class="header__mobile-nav-list">
      <li class="header__mobile-nav-item"><a href="#" class="header__mobile-nav-link">Inicio</a></li>
      <li class="header__mobile-nav-item"><a href="#" class="header__mobile-nav-link">Soluciones</a></li>
      <li class="header__mobile-nav-item"><a href="#" class="header__mobile-nav-link">Características</a></li>
      <li class="header__mobile-nav-item"><a href="#" class="header__mobile-nav-link">Precios</a></li>
      <li class="header__mobile-nav-item"><a href="#" class="header__mobile-nav-link">Demo</a></li>
      <li class="header__mobile-nav-item"><a href="#" class="header__mobile-nav-link">Blog</a></li>
    </ul>
    <div class="header__mobile-actions">
      <button class="header__login-btn">Iniciar sesión</button>
      <button class="header__contact-btn">Contactar ventas</button>
    </div>
  </div>
</header>